import React, {useState, useEffect, useContext} from 'react';
import { AuthContext } from '../../../contexts/authContext';
import axios from 'axios';
import useNotification from '../../../hooks/useNotification';
import config from '../../../config';
import { AddIcon, EditIcon, TrashIcon, CheckSolidIcon, XSolidIcon, CachedIcon } from '../../../assets/icons/icons';
import ManagePoiDialog from './ManagePoiDialog';
import { IconButton } from '@mui/material';
import './Poi.css';
import DeletePoiDialog from './DeletePoiDialog';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { itIT } from '@mui/x-data-grid/locales';
import { AppAuthGlobalVariables } from '../../../contexts/AppAuthContext';
import { DataGridPremium } from '@mui/x-data-grid-premium';

const theme = createTheme(
    {
      palette: {
        primary: { main: '#1976d2' },
      },
    },
    itIT,
);

const PoiCell = (params) => {
    return(
        <div>
            {/* {params.field === 'nearPanels' ? params?.value?.SS.join(', ') : params?.value?.S} */}
            {params.value}
        </div>
    )
}

const ActionCell = (params, openDialog, openDeleteDialog) => {
    return(
        <div>
            <IconButton onClick={() => openDialog('mod')} size='small' >
                <EditIcon addClass='pointer'></EditIcon>
            </IconButton>
            <IconButton onClick={openDeleteDialog} size='small'>
                <TrashIcon addClass="pointer" ></TrashIcon>
            </IconButton>
        </div>
    )
}

const ActionHeaderCell = (params, openDialog, getPois) => {
    return(
        <div className="centered-cell" >
            <IconButton title='Ricarica dati' onClick={() => {getPois()}} size='small' >
                <CachedIcon addClass='pointer'/>
            </IconButton>
            <IconButton onClick={() => openDialog('ins')} size='small' >
                <AddIcon addClass='pointer'/>
            </IconButton>
        </div>
    )
}

const PhotoCell = (params) => {
    if(params.value){
        return <CheckSolidIcon addClass='green-txt'/>
    }else{
        return <XSolidIcon addClass='red-txt'/>
    }
}

function Poi(props) {
    const auth = useContext(AuthContext);
    const {poi, setPoi} = useContext(AppAuthGlobalVariables);
    const { notificationError } = useNotification();

    const [loading, setLoading] = useState(true);
    const [poiLoading, setPoiLoading] = useState(true);
    const [lastCellData, setLastCellData] = useState(null)

    const [openManagePoiDialog, setOpenManagePoiDialog] = useState(false);
    const [openDeletePoiDialog, setOpenDeletePoiDialog] = useState(false);

    const columns = [
        {field: 'ACTION', headerClassName: 'header-cell action-cell', headerName: '', type: 'string', width: 75, align: 'center', headerAlign: 'center', disableColumnMenu: true, sortable: false, renderHeader: (params) => ActionHeaderCell(params, handleOpenManagePoiDialog, getPois), renderCell: (params) => ActionCell(params, handleOpenManagePoiDialog, handleOpenDeletePoiDialog)},
        {field: 'idEntita', headerClassName: 'header-cell idEntita', headerName: 'Id Entità', type: 'string', width: 100, align: 'left', headerAlign: 'left', renderCell: (params) => PoiCell(params), valueGetter: (params) => params?.S},
        {field: 'itname', headerClassName: 'header-cell itname', headerName: 'Nome', type: 'string', width: 250, align: 'left', headerAlign: 'left', renderCell: (params) => PoiCell(params), valueGetter: (params) => params?.S},
        //{field: 'nearPanels', headerClassName: 'header-cell panels', headerName: 'Pannelli associati', type: 'string', width: 250, align: 'left', headerAlign: 'left', renderCell: (params) => PoiCell(params), valueGetter: (params) => params?.SS?.join(', ') || ''},
        {field: 'lat', headerClassName: 'header-cell latitude', headerName: 'Latitudine', type: 'string', width: 150, align: 'right', headerAlign: 'right', renderCell: (params) => PoiCell(params), valueGetter: (params) => params?.S},
        {field: 'lon', headerClassName: 'header-cell longitude', headerName: 'Longitudine', type: 'string', width: 150, align: 'right', headerAlign: 'right', renderCell: (params) => PoiCell(params), valueGetter: (params) => params?.S},
        {field: 'photo', headerClassName: 'header-cell photo', headerName: 'Foto', type: 'string', width: 100, align: 'center', headerAlign: 'center', renderCell: (params) => PhotoCell(params), valueGetter: (params) => params?.S},
    ]
    
    useEffect(() => {
        if(!poi.length){
            getPois();
        }else{
            setPoiLoading(false);
            setLoading(false);
        }
    }, [])

    useEffect(() => {
        if(!loading){
            getPois();
        }
    }, [props.city])

    const getPois = async() => {
        
        try {
            setLoading(true);
            setPoiLoading(true);

            const params = {
                city: props.city
            };

            const axiosParams = {
                url: '/get-pois',
                method: 'get',
                baseURL: config.API_URL,
                headers: { Authorization: `Bearer ${auth.sessionInfo?.accessToken}` },
                params
            };

            const response = await axios(axiosParams);

            //setRows(response.data.dataToReturn);
            setPoi(response.data.dataToReturn)
            setPoiLoading(false);
            setLoading(false);
        } catch (error) {
            if (error?.status === 401 || error?.status === 403) {
                props.logout();
            } else {
                if (typeof error.response.data.errorMessage === 'string') {
                    notificationError(error.response.data.errorMessage);
                } else {
                    notificationError('Oops, an error has occured');
                }
            }
            setPoiLoading(false);
            setLoading(false);
        }
    }
    
    const handleOpenManagePoiDialog = (action) => {
        setOpenManagePoiDialog(action);
    }

    const handleCloseManagePoiDialog = () => {
        setOpenManagePoiDialog(false);
    }

    const handleOpenDeletePoiDialog = () => {
        setOpenDeletePoiDialog(true);
    }

    const handleCloseDeletePoiDialog = () => {
        setOpenDeletePoiDialog(false)
    }

    return (
        <div className='component-container poi'>
            <div className='component-card'> 
                <ThemeProvider theme={theme}>
                    <DataGridPremium
                        rows={poi}
                        columns={columns}
                        className="poi-table"
                        loading={poiLoading}
                        rowHeight={30}
                        onCellClick={(params) => setLastCellData(params.row)}
                        getRowId={(row) => { return row.idEntita.S}}
                        disableAggregation
                        disableRowGrouping
                        disableDensitySelector
                    />
                </ThemeProvider>
            </div>
            <ManagePoiDialog {...{
                openManagePoiDialog,
                handleCloseManagePoiDialog,
                lastCellData,
                getPois,
                city: props.city
            }}/>
            <DeletePoiDialog {...{
                openDeletePoiDialog,
                handleCloseDeletePoiDialog,
                lastCellData,
                getPois
            }}/>
        </div>
    )
}

export default Poi